import Get from 'lodash/get';

export const isLoading = state => Get(state, 'storageBins.loading', false);
export const getStorageBin = state => Get(state, 'storageBins.storageBin', {});
export const isSaving = state => Get(state, 'storageBins.saving', false);
